<script setup lang="ts">
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu'
import { useDashboardSections } from '@/composables/useDashboardSections'

const { sections: components } = useDashboardSections()
</script>

<template>
  <NavigationMenu>
    <NavigationMenuList>
      <NavigationMenuItem>
        <NavigationMenuTrigger
          class="border-input cursor-pointer border bg-gray-100 text-black"
        >
          {{ $t('common.menu.manage') }}
        </NavigationMenuTrigger>
        <NavigationMenuContent>
          <ul
            data-testid="navigation-wrapper"
            class="grid w-105 gap-3 p-4 md:w-160 md:grid-cols-2 lg:w-190 lg:grid-cols-3"
          >
            <li
              v-for="component in components"
              :key="component.title"
              class="h-full"
              :data-testid="`navigation-${component.name}`"
            >
              <RouterLink v-slot="{ href }" :to="{ name: component.name }">
                <NavigationMenuLink :as-child="true">
                  <a
                    :href="href"
                    class="hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground block space-y-1 rounded-md p-3 leading-none no-underline transition-colors outline-none select-none"
                  >
                    <div
                      class="flex items-center gap-2 text-sm leading-none font-medium"
                    >
                      <component :is="component.icon" v-if="component.icon" />
                      {{ $t(component.title) }}
                    </div>
                    <p
                      class="text-muted-foreground line-clamp-2 text-sm leading-snug"
                    >
                      {{ $t(component.description) }}
                    </p>
                  </a>
                </NavigationMenuLink>
              </RouterLink>
            </li>
          </ul>
        </NavigationMenuContent>
      </NavigationMenuItem>
    </NavigationMenuList>
  </NavigationMenu>
</template>
